import { OptionModel } from "../types/OptionModel";

 



export const getSelectedValueFromId = (id: any, list: Array<OptionModel>) => {

    var index = list.findIndex(w => w.value == id);
    if (index != -1) {
        return list[index];
    }
    return null;
}